var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdLeagueGifts } from "../../constants/IdLeagueGifts";
import { EventType } from "../balancing/types/BalancingCore";
import { TypeActionTournament } from "./actionTournament";
var initial = {
    giftLevel: 9999,
    id: -1,
    leagueGiftType: IdLeagueGifts.LeagueFreeGift,
    leagueType: EventType.PlayerLeague,
    name: "initial",
};
export var reducerOngoingLeagueReward = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionTournament.SetCurrentRewardInfo:
            return __assign({}, action.currentPackage, { giftLevel: action.giftLevel, leagueGiftType: action.leagueGiftType, leagueType: action.leagueId });
        case TypeActionTournament.RemoveCurrentRewardInfo:
            return initial;
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/reducerOngoingLeagueRewardInfo.ts
// module id = 2982
// module chunks = 3